import { FC, PropsWithChildren, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { useTypedTranslationsWithPartialResult } from '~/components/translation/use-translations';
import textKeyIsSet from '~/utils/textkey-is-set';

type CasinoProviderSeoHeaderProps = PropsWithChildren<{
	titleFallBackTextkey: string;
}>;

const CasinoProviderSeoHeader: FC<CasinoProviderSeoHeaderProps> = ({ children, titleFallBackTextkey }) => {
	const { providerName } = useParams() as { providerName: string };

	const titleTextKey = useMemo(() => {
		switch (providerName) {
			case 'PLAY_N_GO':
				return 'CASINO_PNG_GAMES_TITLE';
			case 'CASINO_MICROGAMING':
				return 'CASINO_MG_GAMES_TITLE';
			case 'NOLIMITCITY':
				return 'CASINO_NLC_GAMES_TITLE';
			case 'QUICKSPIN':
				return 'CASINO_QKS_GAMES_TITLE';
			default:
				return `CASINO_${providerName}_GAMES_TITLE`;
		}
	}, [providerName]);

	const typedTranslations = useTypedTranslationsWithPartialResult({
		titleTextKey,
		titleFallBackTextkey
		// descriptionTextKey
	});

	const siteTitle = textKeyIsSet(typedTranslations.translations[titleTextKey])
		? typedTranslations.translations[titleTextKey]
		: typedTranslations.translations[titleFallBackTextkey];

	// const description = typedTranslations.translations[descriptionTextKey];

	return (
		<Helmet>
			{textKeyIsSet(siteTitle) && <title>{siteTitle}</title>}
			{/* {textKeyIsSet(description) && <meta name="description" content={description} />} */}
			{children}
		</Helmet>
	);
};

export default CasinoProviderSeoHeader;
